/**
 * What the old SaySomethingIn app says about this learner (job #749), as it
 * rides the /api/entitlement/user answer. The server decides; this only holds
 * the summary for the quiet Settings card. Never a lock: access itself comes
 * through the ordinary entitlements list.
 */
import { ref } from 'vue'

export interface LegacyAccessSummary {
  state: 'active' | 'grace' | 'lapsed' | 'none'
  source: 'stub' | 'live'
  carried: boolean
  graceUntil: string | null
  offer: boolean
}

export const legacyAccess = ref<LegacyAccessSummary | null>(null)

/**
 * The old app has never answered for this learner (ask 681). The player holds
 * at the wall instead of raising it while this is true, and asks there
 * (useUserEntitlements.settleOldApp). Only ever true when the server said so.
 */
export const legacyAnswerPending = ref(false)

const STATES = ['active', 'grace', 'lapsed', 'none']

export function noteLegacyFromEntitlementAnswer(data: unknown): void {
  legacyAnswerPending.value = (data as { legacyPending?: unknown } | null)?.legacyPending === true
  const l = (data as { legacy?: Partial<LegacyAccessSummary> | null } | null)?.legacy
  legacyAccess.value = l && typeof l.state === 'string' && STATES.includes(l.state)
    ? {
        state: l.state as LegacyAccessSummary['state'],
        source: l.source === 'live' ? 'live' : 'stub',
        carried: l.carried === true,
        graceUntil: typeof l.graceUntil === 'string' ? l.graceUntil : null,
        offer: l.offer === true,
      }
    : null
}
